export default __webpack_public_path__ + "static/media/further.e5583e5c.png";